// index.js
import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { HiOutlineBellAlert } from "react-icons/hi2";


const root = ReactDOM.createRoot(document.getElementById("root"));

function AppWrapper() {
    const [isMobile, setIsMobile] = useState(false);
  
    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= 836);
      };
  
      window.addEventListener("resize", handleResize);
      handleResize();
  
      return () => window.removeEventListener("resize", handleResize);
    }, []);
  
    if (isMobile) {
        return (
            <div className="message-overlay">
              <div className="message-box">
                <div className="message-icon-wrapper">
                  <HiOutlineBellAlert className="message-icon" />
                </div>
                <p>Fadlan adeegso laptop ama desktop, amaba shaashad cabbirka ballaceedu ka weyn yahay 836px, si aad u awoodo inaad website-kan adeegsato.</p>
              </div>
            </div>
          );
        }
  
    return <App />;
  }
  

root.render(<AppWrapper />);
